import React, { useEffect, useState } from 'react';
import './NowPlayingBar.scss';
import SliderPlaying from './SliderPlaying';
import SliderVolume from './SliderVolume';
import { useDataLayerValue } from '../../../DataLayer';
import firebase from 'firebase';
import { db } from '../../../firebase';
import { Link, useHistory } from 'react-router-dom';
import { ICONS } from '../../../constants/icons';


function NowPlayingBar(props) {

    const [{ playing, playing_loading, volume, volume_old, song_playing, lang, loop, shuffle, playlists, playlist_song_love, user, playlist_id_now, playback_rate }, dispatch] = useDataLayerValue();
    const [isUpdating, setIsUpdating] = useState(false);
    const [playlistIdNow, setPlaylistIdNow] = useState(playlist_id_now);
    const history = useHistory();

    useEffect(() => {
        setPlaylistIdNow(playlist_id_now);
    }, [playlist_id_now]);


    const handlePlaying = () => {
        if (!playing_loading) {
            dispatch({
                type: 'SET_PLAYING',
                playing: !playing
            });
        }
    };
    const notiLang = {
        en: {
            add_song: 'Add to your Love songs.',
            remove_song: 'Remove from your Love songs.',
            should_login_before_love_song: 'Please login before adding songs to your Love songs!'
        },
        vi: {
            add_song: 'Thích bài hát thành công.',
            remove_song: 'Bỏ thích bài hát thành công.',
            should_login_before_love_song: 'Vui lòng đăng nhập trước khi thêm bài hát vào danh sách yêu thích!'
        }
    };
    const handleClickVolume = () => {
        const v = volume;
        if (volume > 0) {
            dispatch({
                type: 'SET_VOLUME_OLD',
                volume_old: v
            });
            dispatch({
                type: 'SET_VOLUME',
                volume: 0
            });
        } else {
            const v_o = volume_old > 0 ? volume_old : 0;
            dispatch({
                type: 'SET_VOLUME',
                volume: v_o
            });
        }
    };

    const handleRepeat = () => {
        if (loop === 0) {
            dispatch({
                type: 'SET_LOOP',
                loop: 2
            });
            return;
        }
        if (loop === 2) {
            dispatch({
                type: 'SET_LOOP',
                loop: 1
            });
        } else {
            dispatch({
                type: 'SET_LOOP',
                loop: 0
            });
        }

    };

    const handleShuffle = () => {
        dispatch({
            type: 'SET_SHUFFLE',
            shuffle: !shuffle
        });
    };

    const handlePlayingSongPreviousOrNext = (typeAction) => {
        const arrAction = ['previous', 'next'];
        if (!arrAction.includes(typeAction)) { return; }
        const indexSongNow = playlists.indexOf(song_playing.id);
        const indexSongNext = typeAction === 'previous' ? (indexSongNow - 1) : (indexSongNow + 1);
        const idSong = (playlists[indexSongNext] !== undefined && playlists[indexSongNext] !== null ? playlists[indexSongNext] : playlists[indexSongNow]);
        if (idSong) {
            dispatch({
                type: 'SET_PLAYING_SONG_BY_ID',
                playing_song_by_id: idSong
            });
            dispatch({
                type: 'SET_PLAYING_LOADING',
                playing_loading: true
            });
        }
    };

    const handleShowPlaylistNow = () => {
        if (playlistIdNow !== null && playlistIdNow.trim() !== '') {
            history.push(`/playlist/${playlistIdNow}`);
        }
    };

    const handlePlaybackRate = () => {
        if (parseFloat(playback_rate) < 3) {
            dispatch({
                type: 'SET_PLAYBACK_RATE',
                playback_rate: parseFloat(parseFloat(playback_rate) + 0.25).toFixed(2)
            });
        } else {
            dispatch({
                type: 'SET_PLAYBACK_RATE',
                playback_rate: parseFloat(1).toFixed(2)
            });
        }
    };

    const handleSaveSongToLibrary = async () => {
        let playlist_song_love_update = [...playlist_song_love];
        const song_playing_id = song_playing.id;
        if (user !== null && isUpdating === false) {
            setIsUpdating(true);
            if (playlist_song_love_update.includes(song_playing_id)) {
                //Remove song in my playlist love
                const indexOfSong = playlist_song_love_update.indexOf(song_playing_id);
                playlist_song_love_update.splice(indexOfSong, 1)
                dispatch({
                    type: 'SET_PLAYLIST_SONG_LOVE',
                    playlist_song_love: playlist_song_love_update
                });
                dispatch({
                    type: 'SET_NOTI',
                    noti: `${lang === 'en' ? notiLang.en.remove_song : notiLang.vi.remove_song}`
                });
                const docDataUpdate = {
                    playlist_love_song: playlist_song_love_update,
                    updated_at: firebase.firestore.Timestamp.now(),
                };
                await db.collection("users").doc(user.user_uid).update(docDataUpdate);
                setIsUpdating(false);
            } else {
                //Add song in my playlist love
                dispatch({
                    type: 'SET_PLAYLIST_SONG_LOVE',
                    playlist_song_love: [...playlist_song_love_update, song_playing_id]
                });
                dispatch({
                    type: 'SET_NOTI',
                    noti: `${lang === 'en' ? notiLang.en.add_song : notiLang.vi.add_song}`
                });
                const docDataUpdate = {
                    playlist_love_song: [...playlist_song_love_update, song_playing_id],
                    updated_at: firebase.firestore.Timestamp.now(),
                };
                await db.collection("users").doc(user.user_uid).update(docDataUpdate);
                setIsUpdating(false);
            }

        } else {
            if (user === null) {
                dispatch({
                    type: 'SET_NOTI',
                    noti: `${lang === 'en' ? notiLang.en.should_login_before_love_song : notiLang.vi.should_login_before_love_song}`
                });
            }

        }

    };
    return (
        <div className="now-playing-bar-container" >
            <div className="now-playing-bar__left">
                <div className="now-playing__cover-art">
                    <Link to={`/song/${song_playing.id}`} >
                        <img src={song_playing.avatar ? song_playing.avatar : ''} alt="cover-art" />
                    </Link>
                </div>
                <div className="nowplaying-track-link">
                    <div className="ellipsis-one-line">
                        <Link to={`/song/${song_playing.id}`} className="nowplaying-track-link_song">
                            {lang === "en" ? song_playing.name_en : song_playing.name_vi}
                        </Link>
                    </div>
                    <div className="ellipsis-one-line">
                        <Link to={`/song/${song_playing.id}`} className="nowplaying-track-link_singer">
                            {song_playing.singer ? song_playing.singer : ''}
                        </Link>
                    </div>
                </div>
                <div className="control-button-wrapper">
                    <div className="control-button">
                        <button type="button" className="control-button-heart" title="Save to Your Library" onClick={handleSaveSongToLibrary}>
                            {playlist_song_love && playlist_song_love.includes(song_playing.id) ? (<svg role="img" height="16" width="16" viewBox="0 0 16 16" className="fill-heart">
                                <path fill="none" d="M0 0h16v16H0z"></path>
                                <path d="M13.797 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253c-.77.77-1.194 1.794-1.194 2.883s.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195a4.052 4.052 0 001.195-2.883 4.057 4.057 0 00-1.196-2.883z"></path>
                            </svg>) : (<svg role="img" height="16" width="16" viewBox="0 0 16 16">
                                <path fill="currentColor" d="M13.764 2.727a4.057 4.057 0 00-5.488-.253.558.558 0 01-.31.112.531.531 0 01-.311-.112 4.054 4.054 0 00-5.487.253A4.05 4.05 0 00.974 5.61c0 1.089.424 2.113 1.168 2.855l4.462 5.223a1.791 1.791 0 002.726 0l4.435-5.195A4.052 4.052 0 0014.96 5.61a4.057 4.057 0 00-1.196-2.883zm-.722 5.098L8.58 13.048c-.307.36-.921.36-1.228 0L2.864 7.797a3.072 3.072 0 01-.905-2.187c0-.826.321-1.603.905-2.187a3.091 3.091 0 012.191-.913 3.05 3.05 0 011.957.709c.041.036.408.351.954.351.531 0 .906-.31.94-.34a3.075 3.075 0 014.161.192 3.1 3.1 0 01-.025 4.403z"></path>
                            </svg>)
                            }
                        </button>
                        <button className="control-button-picture-in-picture">
                            <svg width="16" height="16"  ><g fill="currentColor" ><path d="M1 3v9h14V3H1zm0-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"></path><path d="M10 8h4v3h-4z"></path></g></svg>
                        </button>
                    </div>
                </div>
            </div>

            <div className="now-playing-bar__center">
                <div className="player-controls">
                    <div className="player-controls__buttons">
                        <div className="control-button-wrapper">
                            <button className={`control-button ${shuffle && 'btn-active-shuffle'}`} title="Enable shuffle" onClick={handleShuffle}>
                                <svg height="20" viewBox="0 -2 19 19" fill="currentColor" >
                                    <path d="M0 3.5A.5.5 0 0 1 .5 3H1c2.202 0 3.827 1.24 4.874 2.418.49.552.865 1.102 1.126 1.532.26-.43.636-.98 1.126-1.532C9.173 4.24 10.798 3 13 3v1c-1.798 0-3.173 1.01-4.126 2.082A9.624 9.624 0 0 0 7.556 8a9.624 9.624 0 0 0 1.317 1.918C9.828 10.99 11.204 12 13 12v1c-2.202 0-3.827-1.24-4.874-2.418A10.595 10.595 0 0 1 7 9.05c-.26.43-.636.98-1.126 1.532C4.827 11.76 3.202 13 1 13H.5a.5.5 0 0 1 0-1H1c1.798 0 3.173-1.01 4.126-2.082A9.624 9.624 0 0 0 6.444 8a9.624 9.624 0 0 0-1.317-1.918C4.172 5.01 2.796 4 1 4H.5a.5.5 0 0 1-.5-.5z" />
                                    <path d="M13 5.466V1.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192zm0 9v-3.932a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384l-2.36 1.966a.25.25 0 0 1-.41-.192z" />
                                </svg>
                            </button>
                        </div>
                        <div className="control-button-wrapper">
                            <button className="control-button  control-button--disabled" title="Previous" aria-label="Previous" disabled="" onClick={() => handlePlayingSongPreviousOrNext('previous')}>
                                <svg height="20" viewBox="1 1 13 13" fill="currentColor" >
                                    <path d="M4.5 3.5A.5.5 0 0 0 4 4v8a.5.5 0 0 0 1 0V4a.5.5 0 0 0-.5-.5z" />
                                    <path d="M4.903 8.697l6.364 3.692c.54.313 1.232-.066 1.232-.697V4.308c0-.63-.692-1.01-1.232-.696L4.903 7.304a.802.802 0 0 0 0 1.393z" />
                                </svg>
                            </button>
                        </div>
                        <div className="control-button-wrapper">
                            <button className="control-button  control-button--circled" title="Play" aria-label="Play" onClick={handlePlaying}>
                                {
                                    playing_loading ? (<img src={ICONS.loading} className="loading" alt="icon loading" />) : (playing ? (<svg viewBox="0 0 16 16" fill="currentColor" >
                                        <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" />
                                    </svg>) : (<svg height="20" viewBox="0 0 14 16" fill="currentColor" >
                                        <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                                    </svg>))
                                }

                            </button>
                        </div>
                        <div className="control-button-wrapper">
                            <button className="control-button " title="Next" aria-label="Next" onClick={() => handlePlayingSongPreviousOrNext('next')}>
                                <svg height="20" viewBox="1 1 13 13" fill="currentColor" >
                                    <path d="M12 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z" />
                                    <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                                </svg>
                            </button>
                        </div>
                        <div className="control-button-wrapper" >
                            <button className={`control-button ${loop !== 0 ? `btn-active-repeat type-repeat-${parseInt(loop)}` : ''}`} title="Enable repeat" aria-label="Enable repeat" onClick={handleRepeat}>
                                <svg height="20" viewBox="0 -1 16 16" fill="currentColor" >
                                    <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                                    <path d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <SliderPlaying totalTime={song_playing.time} isMobile={false} isMobileShowTime={false} />

                </div>
            </div>


            <div className="now-playing-bar__right">
                <div className="extra-controls">
                    <button className="control-button" onClick={handlePlaybackRate}>
                        <label htmlFor="" className="speed-playing">{playback_rate}x</label>
                    </button>
                    <button className="control-button " aria-label="Playlist now" onClick={handleShowPlaylistNow}>
                        <svg width="1.4em" height="1.4em" viewBox="0 0 16 16" className="bi bi-blockquote-right" fill="currentColor" >
                            <path d="M2 3.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />
                            <path d="M12.168 6.352c.184.105.332.197.445.275.114.074.229.174.346.299.11.117.193.24.252.369s.1.295.123.498h-.281c-.243 0-.432.06-.569.182-.14.117-.21.29-.21.521 0 .164.062.318.187.463.121.14.289.21.504.21.336 0 .576-.108.72-.327.145-.223.217-.514.217-.873 0-.254-.054-.485-.164-.692a2.436 2.436 0 0 0-.398-.562c-.16-.168-.33-.31-.51-.428-.18-.117-.33-.213-.451-.287l-.211.352zm-2.168 0c.184.105.332.197.445.275.114.074.229.174.346.299.113.12.2.246.258.375.055.125.094.289.117.492h-.281c-.242 0-.432.06-.569.182-.14.117-.21.29-.21.521 0 .164.062.318.187.463.121.14.289.21.504.21.336 0 .576-.108.72-.327.145-.223.217-.514.217-.873 0-.254-.054-.485-.164-.692a2.438 2.438 0 0 0-.398-.562c-.16-.168-.33-.31-.51-.428-.18-.117-.33-.213-.451-.287L10 6.352z" />
                        </svg>
                    </button>
                    <button className="control-button " title="Clock" aria-label="Clock">
                        <svg width="1.2em" height="1.2em" viewBox="0 0 16 16" className="bi bi-clock" fill="currentColor" >
                            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm8-7A8 8 0 1 1 0 8a8 8 0 0 1 16 0z" />
                            <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z" />
                        </svg>
                    </button>
                    <div className="volume-bar" dir="ltr">
                        <button className="control-button volume-bar__icon" aria-label="Mute" onClick={handleClickVolume}>
                            {parseFloat(volume) === 0 ? (<svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-volume-up" fill="currentColor" >
                                <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM6 5.04L4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96V5.04zm7.854.606a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708l4-4a.5.5 0 0 1 .708 0z" />
                                <path d="M9.146 5.646a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0z" />
                            </svg>) : (<svg width="1.5em" height="1.5em" viewBox="0 0 16 16" className="bi bi-volume-up" fill="currentColor" >
                                <path d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06zM6 5.04L4.312 6.39A.5.5 0 0 1 4 6.5H2v3h2a.5.5 0 0 1 .312.11L6 10.96V5.04z" />
                                {
                                    parseFloat(volume) > 0.8 && (<path d="M11.536 14.01A8.473 8.473 0 0 0 14.026 8a8.473 8.473 0 0 0-2.49-6.01l-.708.707A7.476 7.476 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303l.708.707z" />)
                                }
                                {
                                    parseFloat(volume) > 0.4 && (<path d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.483 5.483 0 0 1 11.025 8a5.483 5.483 0 0 1-1.61 3.89l.706.706z" />)
                                }
                                <path d="M8.707 11.182A4.486 4.486 0 0 0 10.025 8a4.486 4.486 0 0 0-1.318-3.182L8 5.525A3.489 3.489 0 0 1 9.025 8 3.49 3.49 0 0 1 8 10.475l.707.707z" />)
                            </svg>)
                            }
                        </button>
                        <div className="progress-bar">
                            <SliderVolume />
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default NowPlayingBar;